import React from "react";
import { Typography } from "@material-ui/core";
import moment from "moment";

const EmailHistory = ({ item }) => {
  if (item.emailHistory?.length > 0) {
    return (
      <>
        {item.emailHistory
          .filter((email) => email.sentAt)
          .sort((a, b) => new Date(a.sentAt) - new Date(b.sentAt))
          .map((email, idx) => (
            <Typography
              key={idx}
              variant="body2"
              color="textSecondary"
              style={{ marginTop: idx === 0 ? 12 : 4 }}
            >
              {email.type} email sent on{" "}
              {moment(email.sentAt).format("DD MMM YYYY [at] hh:mm A")}
              {email.email ? ` to ${email.email}` : ""}
              {email.sentBy ? ` by ${email.sentBy}` : ""}
            </Typography>
          ))}
      </>
    );
  }

  // Backward compatibility for old recruitments
  return (
    <Typography variant="body2" color="textSecondary" style={{ marginTop: 12 }}>
      {item.referenceConfirmationSentAt
        ? `Reference mail sent on ${moment(
            item.referenceConfirmationSentAt,
          ).format("DD MMM YYYY [at] hh:mm A")}`
        : "Reference mail sent"}
    </Typography>
  );
};

export default EmailHistory;
